/**
 * Web component for the launch popup
 * Uses 1 type of cookies
 *
 */

(async () => {
  if (!customElements.get('launch-popup')) {
    const { Fancybox } = await import('@fancyapps/ui');
    const { default: Cookies } = await import('js-cookie');

    class LaunchPopup extends HTMLElement {
      constructor() {
        super();

        // cookie states at loading
        this.LaunchCookie = Cookies.get('launch_popup') ? true : false;
        this.active = Cookies.get('launch_active') ? true : false;

        //  if login cookie does not exist => show it & set it
        if (!this.loginCookie) {
          Cookies.set('launch_popup', 'true', { expires: 14 });
        }

        const LaunchCookie = Cookies.get('launch_popup') ? true : false;
        const launchActive = Cookies.get('launch_active') ? true : false;
        const CountryPopupActive = Cookies.get('country_popup_open') ? true : false;

        //Only open launch popup when country popup isn't open
        window.addEventListener('load', () => {
          if (!CountryPopupActive) {
            if (LaunchCookie && !launchActive) {
              this.open('default');
              Cookies.set('launch_active', 'true', { expires: 14 });
            }
          }
        });

        document.querySelectorAll('[data-country-popup-close]').forEach((button) => {
          button.addEventListener('click', (e) => {
            if (LaunchCookie && !launchActive) {
              this.open('default');
              Cookies.set('launch_active', 'true', { expires: 14 });
            }
          });
        });

        if (Shopify.designMode) {
          // Open popup in customiser when the section event is triggerd
          window.addEventListener('shopify:section:load', (event) => {
            this.close('default');
            this.open('default');
          });
        }

        // Selectors
        this.popup = this.querySelector('[data-launch-popup-wrapper]');
      }

      /**
       * Open the launch popup
       * @type = 'default'
       * @returns void
       */
      open(type) {
        // Close button event listener
        this.querySelectorAll('[data-launch-popup-close]').forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        });
        if (this.popup) {
          if (this.popup.classList.contains('launch-popup--large')) {
            this.fancyboxClasses = 'fancybox-launch-popup fancybox-launch-popup-large';
          }
          if (this.popup.classList.contains('launch-popup--small')) {
            this.fancyboxClasses = 'fancybox-launch-popup fancybox-launch-popup-small';
          }
        }

        // Open fancybox and set callback for destroy event
        Fancybox.show(
          [
            {
              src: this.popup,
              type: 'html',
            },
          ],
          {
            closeButton: false,
            dragToClose: false,
            width: '100vw',
            mainClass: this.fancyboxClasses,
          }
        );
      }
      /**
       * Close launch popup
       * @returns void
       */
      close() {
        Fancybox.close();
      }
    }

    window.LaunchPopup = LaunchPopup;
    customElements.define('launch-popup', LaunchPopup);
  }
})();
